import { useEffect, useState } from "react";
import FileDialog from "./Dialog/Dialog";
import { Edit, Trash2 } from 'lucide-react';
import EditImageDialog from "./Dialog/EditDialog";
import axiosInstance from "../AxiosInstance";

const TABS = ["ALUMNI", "GALLERY", "ORGANIZATION", "NEWS","HOME", "SEMINARIANS" , "WAWATA" , "ALL"];

const Images = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState("ALUMNI");

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [editingFile, setEditingFile] = useState(null);

  const fetchFiles = async () => {
    try {
      const response = await axiosInstance.get("/files");
      setFiles(response.data);
    } catch (error) {
      console.error("Error fetching files:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const handleAddImageClick = () => {
    setIsDialogOpen(true);
  };

  const handleEditClick = (file) => {
    setEditingFile(file);
    setIsEditDialogOpen(true);
  };

  const handleDeleteClick = async (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      try {
        await axiosInstance.delete(`/files/${id}`);
        setFiles(files.filter(file => file.id !== id));
      } catch (error) {
        console.error("Error deleting file:", error);
      }
    }
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleEditDialogClose = () => {
    setIsEditDialogOpen(false);
    setEditingFile(null);
  };

  const handleSubmitSuccess = (newFile) => {
    // Add only if the new file matches the selected tab (page)
    setFiles([newFile, ...files]);
  };

  const handleEditSuccess = (updatedFile) => {
    setFiles(files.map(file => file.id === updatedFile.id ? updatedFile : file));
    setIsEditDialogOpen(false);
    setEditingFile(null);
  };

  const filteredFiles = selectedTab === "ALL"
    ? files
    : files.filter(file => file.page === selectedTab);


  if (loading) {
    return <p className="text-center mt-10 text-gray-600">Loading files...</p>;
  }


  return (
    <div className="container mx-auto px-4 py-6">
      {/* Tabs */}
      {/* Tabs */}
      <div className="flex flex-wrap sm:flex-nowrap gap-2 sm:gap-4 mb-6 border-b text-gray-900 dark:text-gray-300 overflow-x-auto whitespace-nowrap">
        {TABS.map(tab => (
          <button
            key={tab}
            onClick={() => setSelectedTab(tab)}
            className={`px-3 py-1.5 text-sm sm:text-base border-b-2 font-medium ${selectedTab === tab ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-600'
              } hover:text-blue-600 transition-colors`}
          >
            {tab}
          </button>
        ))}
      </div>


      {/* Add Image Button */}
      <div className="mb-6">
        <button
          onClick={handleAddImageClick}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2"
        >
          <span>ADD image</span>
        </button>
      </div>

      {/* File Dialog */}
      <FileDialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        onSubmitSuccess={handleSubmitSuccess}
        defaultPage={selectedTab} // Optional: pass selected tab to pre-fill "page" field
      />

      {/* Edit Dialog */}
      <EditImageDialog
        open={isEditDialogOpen}
        onClose={handleEditDialogClose}
        onSubmitSuccess={handleEditSuccess}
        fileToEdit={editingFile}
      />

      {/* Images */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {filteredFiles.map((file) => (
          <div
            key={file.id}
            className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden hover:shadow-md transition-shadow"
          >
            <div className="relative">
              <img
                src={file.photoUrl}
                alt={file.name}
                className="w-full h-40 object-cover"
              />
              <div className="absolute top-2 right-2 flex gap-2">
                <button
                  onClick={() => handleEditClick(file)}
                  className="p-2 bg-white/90 rounded-full hover:bg-gray-100 transition-colors"
                  title="Edit"
                >
                  <Edit className="text-gray-700" size={20} />
                </button>
                <button
                  onClick={() => handleDeleteClick(file.id)}
                  className="p-2 bg-white/90 rounded-full hover:bg-red-100 transition-colors"
                  title="Delete"
                >
                  <Trash2 className="text-red-600" size={20} />
                </button>
              </div>
            </div>
            <div className="p-3">
              <h3 className="font-semibold text-lg line-clamp-1">{file.title}</h3>
              <div className="text-sm text-gray-600 dark:text-gray-300 space-y-1 mt-1">
                <p className="line-clamp-1">
                  <span className="font-medium">Name:</span> {file.name}
                </p>
                <p>
                  <span className="font-medium">Page:</span> {file.page}
                </p>
                {file.description && (
                  <p className="line-clamp-2 text-xs">
                    <span className="font-medium">Description:</span> {file.description}
                  </p>
                )}
              </div>
              <p className="text-xs text-gray-400 mt-2">
                {new Date(file.createdAt).toLocaleString()}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Images;
